import React, { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;
const ADD_API = process.env.REACT_APP_ADD_SCHEDULE;
const GET_DOCTOR_API = process.env.REACT_APP_GET_DOCTORE_SCHEDULE;
const UPDATE_API = process.env.REACT_APP_UPDATE_SCHEDULE;
const DELETE_API = process.env.REACT_APP_DELETE_SCHEDULE;
const STATUS_API = process.env.REACT_APP_CHANGE_SCHEDULE_STATUS;

const doctorId = 1;

const weekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const ManageSchedule = () => {
  const [scheduleDays, setScheduleDays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // ==========================
  // Fetch Schedule
  // ==========================
  const fetchSchedule = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${API_URL}/${GET_DOCTOR_API}?doctor_id=1`,
      );

      const result = await res.json();

      let apiData = [];

      if (Array.isArray(result)) {
        apiData = result;
      } else if (Array.isArray(result.data)) {
        apiData = result.data;
      } else if (Array.isArray(result.schedule)) {
        apiData = result.schedule;
      }

      const formatted = apiData.map((item, index) => ({
        id: item.schedule_id || Date.now() + index,
        schedule_id: item.schedule_id || null,
        day: item.day_of_week || "",
        available: item.status === "Active",
        start: item.start_time?.slice(0, 5) || "10:00",
        end: item.end_time?.slice(0, 5) || "19:00",
        slot_duration: item.slot_duration || 30,
      }));

      setScheduleDays(formatted);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchedule();
  }, []);

  // ==========================
  // Add New Row
  // ==========================
  const handleAddSchedule = () => {
    setScheduleDays((prev) => [
      ...prev,
      {
        id: Date.now(),
        schedule_id: null,
        day: "",
        available: true,
        start: "10:00",
        end: "19:00",
        slot_duration: 30,
      },
    ]);
  };

  // ==========================
  // Input Change
  // ==========================
  const handleChange = (id, field, value) => {
    setScheduleDays((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              [field]: value,
            }
          : item,
      ),
    );
  };

  // ==========================
  // Live Toggle Status
  // ==========================
  const handleToggle = async (id) => {
    const row = scheduleDays.find((item) => item.id === id);

    if (!row) return;

    const newStatus = row.available ? "Inactive" : "Active";

    // UI update instantly
    setScheduleDays((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              available: !item.available,
            }
          : item,
      ),
    );

    // Existing DB row only
    if (row.schedule_id) {
      try {
        const formData = new FormData();

        formData.append("schedule_id", row.schedule_id);
        formData.append("status", newStatus);

        await fetch(`${API_URL}/${STATUS_API}`, {
          method: "POST",
          body: formData,
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  // ==========================
  // Delete
  // ==========================
  const handleDelete = async (item) => {
    try {
      if (item.schedule_id) {
        const formData = new FormData();

        formData.append("schedule_id", item.schedule_id);

        await fetch(`${API_URL}/${DELETE_API}`, {
          method: "POST",
          body: formData,
        });
      }

      setScheduleDays((prev) => prev.filter((row) => row.id !== item.id));
    } catch (error) {
      console.error(error);
    }
  };

  // ==========================
  // Save Time / Add
  // ==========================
  const handleSave = async () => {
    try {
      setSaving(true);

      for (const item of scheduleDays) {
        if (!item.day) continue;

        const formData = new FormData();

        formData.append("doctor_id", doctorId);
        formData.append("day_of_week", item.day);
        formData.append("start_time", item.start);
        formData.append("end_time", item.end);
        formData.append("slot_duration", item.slot_duration);
        formData.append("status", item.available ? "Active" : "Inactive");
        
        if (
          item.schedule_id !== null &&
          item.schedule_id !== undefined &&
          item.schedule_id !== ""
        ) {
          formData.append("schedule_id", item.schedule_id);

          await fetch(`${API_URL}/${UPDATE_API}`, {
            method: "POST",
            body: formData,
          });
        } else {
          await fetch(`${API_URL}/${ADD_API}`, {
            method: "POST",
            body: formData,
          });
        }
      }

      alert("Schedule Saved Successfully");
      fetchSchedule();
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    } finally {
      setSaving(false);
    }
  };

  // ==========================
  // UI
  // ==========================
  return (
    <div className="container-fluid p-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <div>
          <h2 className="fw-bold mb-1">Manage Schedule</h2>
          <p className="text-muted mb-0">Add, Edit & Manage Doctor Schedule</p>
        </div>

        <button className="btn btn-primary" onClick={handleAddSchedule}>
          + Add Schedule
        </button>
      </div>

      <div className="card shadow-sm border-0 rounded-4 p-4">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary"></div>
            <p className="mt-3">Loading...</p>
          </div>
        ) : (
          <>
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Day</th>
                    <th>Status</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Slot</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {scheduleDays.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        No Schedule Found
                      </td>
                    </tr>
                  ) : (
                    scheduleDays.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <select
                            className="form-select"
                            value={item.day}
                            onChange={(e) =>
                              handleChange(item.id, "day", e.target.value)
                            }
                          >
                            <option value="">Select Day</option>

                            {weekDays.map((day) => (
                              <option key={day} value={day}>
                                {day}
                              </option>
                            ))}
                          </select>
                        </td>

                        <td>
                          <span
                            className={`badge ${
                              item.available ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {item.available ? "Active" : "Closed"}
                          </span>
                        </td>

                        <td>
                          <input
                            type="time"
                            className="form-control"
                            value={item.start}
                            disabled={!item.available}
                            onChange={(e) =>
                              handleChange(item.id, "start", e.target.value)
                            }
                          />
                        </td>

                        <td>
                          <input
                            type="time"
                            className="form-control"
                            value={item.end}
                            disabled={!item.available}
                            onChange={(e) =>
                              handleChange(item.id, "end", e.target.value)
                            }
                          />
                        </td>

                        <td>
                          <input
                            type="number"
                            className="form-control"
                            min="5"
                            value={item.slot_duration}
                            disabled={!item.available}
                            onChange={(e) =>
                              handleChange(
                                item.id,
                                "slot_duration",
                                e.target.value,
                              )
                            }
                          />
                        </td>

                        <td>
                          <div className="d-flex gap-2 align-items-center">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={item.available}
                                onChange={() => handleToggle(item.id)}
                              />
                            </div>

                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(item)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="text-end mt-4">
              <button
                className="btn btn-success"
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save Schedule"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageSchedule;
